import { servicePage } from '@/constants/routes';

export const buildServiceCategoryHref = (rootSlug: string, categorySlug?: string) =>
    categorySlug && categorySlug !== rootSlug ? `${servicePage}/${rootSlug}/${categorySlug}` : `${servicePage}/${rootSlug}`;
